document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll('.Accordions__single');

  accordions.forEach(accordion => {
      const heading = accordion.querySelector('.heading');
      const content = accordion.querySelector('.content');

      content.style.transition = "max-height 0.3s ease-out";
      content.style.overflow = "hidden";

      heading.addEventListener('click', function() {
          const isActive = accordion.classList.contains('active');

          accordions.forEach(acc => {
              acc.classList.remove('active');
              acc.querySelector('.content').style.maxHeight = "0";
          });

          if (!isActive) {
              accordion.classList.add('active');
              content.style.maxHeight = content.scrollHeight + "px";
          }
      });
  });
});
